export const isMacOs = () => {
  return navigator.appVersion.indexOf('Mac') !== -1;
};

export const isWinOS = () => {
  return navigator.appVersion.indexOf('Win') !== -1;
};
